export const getRefineTagsByCategory = (category: string) =>
  ({
    all: [
      { slug: 'y2k', label: 'Y2K', image: '/images/groups/all-y2k.png' },
      {
        slug: 'streetwear',
        label: 'Streetwear',
        image: '/images/groups/all-streetwear.png',
      },
      {
        slug: 'retro',
        label: 'Retro',
        image: '/images/groups/all-retro.png',
      },
    ],
    branding: [
      { slug: 'y2k', label: 'Y2K', image: '/images/groups/logos-y2k.png' },
      {
        slug: 'stickers',
        label: 'Stickers',
        image: '/images/groups/logos-stickers.png',
      },
      {
        slug: 'minimal',
        label: 'Minimal',
        image: '/images/groups/logos-minimal.png',
      },
    ],
    apparel: [
      {
        slug: 'kittl-ai',
        label: 'Kittl AI',
        image: '/images/groups/tshirts-kittlai.png',
      },
      {
        slug: 'streetwear',
        label: 'Streetwear',
        image: '/images/groups/tshirts-streetwear.png',
      },
      {
        slug: 'retro',
        label: 'Retro',
        image: '/images/groups/tshirts-retro.png',
      },
    ],
    labels: [
      {
        slug: 'other-goods',
        label: 'Other goods',
        image: '/images/groups/labels-other-goods.png',
      },
      {
        slug: 'beverages',
        label: 'Beverages',
        image: '/images/groups/labels-beverages.png',
      },
      {
        slug: 'cosmetics',
        label: 'Cosmetics',
        image: '/images/groups/labels-cosmetics.png',
      },
    ],
    marketing: [
      {
        slug: 'motivational',
        label: 'Motivational',
        image: '/images/groups/posters-motivational.png',
      },
      {
        slug: 'inspirational',
        label: 'Inspirational',
        image: '/images/groups/posters-inspirational.png',
      },
      {
        slug: 'vintage',
        label: 'Vintage',
        image: '/images/groups/posters-movie-posters.png',
      },
    ],
    stationery: [
      {
        slug: 'event',
        label: 'Event',
        image: '/images/groups/cards-business-cards.png',
      },
      {
        slug: 'birthday',
        label: 'Birthday',
        image: '/images/groups/cards-birthday.png',
      },
      {
        slug: 'greetings',
        label: 'Greetings',
        image: '/images/groups/cards-greetings.png',
      },
    ],
    social: [
      {
        slug: 'promotional',
        label: 'Promotional',
        image: '/images/groups/social-promotional.png',
      },
      {
        slug: 'inspirational',
        label: 'Inspirational',
        image: '/images/groups/social-inspirational.png',
      },
      {
        slug: 'event',
        label: 'Event',
        image: '/images/groups/social-events.png',
      },
    ],
    covers: [
      {
        slug: 'journals',
        label: 'Journals',
        image: '/images/groups/covers-journals.png',
      },
      {
        slug: 'novels',
        label: 'Novels',
        image: '/images/groups/covers-novels.png',
      },
      {
        slug: 'non-fiction',
        label: 'Non-fiction',
        image: '/images/groups/covers-non-fiction.png',
      },
    ],
    home: [
      {
        slug: 'retro',
        label: 'Retro',
        image: '/images/groups/tshirts-retro.png',
      },
      {
        slug: 'love',
        label: 'Love',
        image: '/images/groups/living-love.png',
      },
      {
        slug: 'coffee',
        label: 'Coffee',
        image: '/images/groups/living-coffee.png',
      },
    ],
  })[category];
